import React, { useState } from 'react';
import {
    DTable,
    isMultipleCell,
    ICell,
    makeObjColClickable,
} from '@/components';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { OptProductListStore } from '../store';
import { runInAction } from 'mobx';
import { applyCustomConfToCellsSelector } from '@/components/common/form/advanced-filters';
import { useOptDrawerSnippets } from '@/pages/sales-follow-up/opt/list/drawer/hooks';

const DemoTable: React.FC<{
    defaultStore: OptProductListStore;
    loading: boolean;
    reload?: any;
}> = ({ defaultStore, loading, reload }) => {
    const [optDrawerOptid, setOptDrawerOptid] = useState(undefined);
    const [optDrawerVis, setOptDrawerVis] = useState(false);
    const [____, optDrawerSnippet] = useOptDrawerSnippets({
        drawerVis: optDrawerVis,
        setDrawerVis: setOptDrawerVis,
        itemId: optDrawerOptid,
    });

    const dataTable = (
        <>
            {optDrawerSnippet}
            <DTable
                onColumnsUpdated={() => reload && reload()}
                defaultStore={defaultStore}
                sceneCode={'crm_opt'}
                propsTransformer={props => {
                    props.loading = loading;
                    props.actions = [];
                    props.onAction = (key, data) => {
                        if (key === 'see-equity-detail') {
                            // 其他动作
                            runInAction(() => {
                                defaultStore.setAction('see-equity-detail');
                                defaultStore.setMutatingData(data);
                            });
                        } else if (_.startsWith(key, 'reveal-obj/')) {
                            // 关联对象都可以点击
                            if (key.indexOf('/opportunity_id') !== -1) {
                                setOptDrawerOptid(
                                    data.opportunity_id?.originalValue,
                                );
                                setOptDrawerVis(true);
                            }
                        }
                    };
                    props.closeRowSelection = true;
                    props.widthInfoKey = 'opt-products-list-default';
                    return props;
                }}
                cellsSelectorTransformer={baiscCellsSelector => {
                    applyCustomConfToCellsSelector(
                        baiscCellsSelector,
                        'equity_detail',
                        () => {
                            const nextCellSelector: ICell<any> = {
                                colKey: 'equity_detail',
                                inputs: ['equity_detail'],
                                cell: 'EquityDetail',
                            };
                            return nextCellSelector;
                        },
                    );

                    makeObjColClickable(baiscCellsSelector, 'opportunity_id');
                    return baiscCellsSelector;
                }}
            />
        </>
    );

    return dataTable;
};

const FinalDemoTable = observer(DemoTable);
export default FinalDemoTable;
